export const REQ_LIST_MESSAGES_ADMIN = 'REQ_LIST_MESSAGES_ADMIN'
export const REC_LIST_MESSAGES_ADMIN = 'REC_LIST_MESSAGES_ADMIN'


export const reqListMessagesAdmin = (config) => ({type: REQ_LIST_MESSAGES_ADMIN, config: config})
export const recListMessagesAdmin = data => ({type: REC_LIST_MESSAGES_ADMIN, data})
